/** True on phones/tablets (not necessarily an in-app webview). */
export function isMobileBrowser() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  return /iPhone|iPad|iPod|Android|Mobile/i.test(ua);
}

/** Facebook, Instagram, X/Twitter, etc. — popups are blocked; GIS redirect is required. */
export function isInAppBrowser() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  return /FBAN|FBAV|Instagram|Twitter|LinkedInApp|Line\/|MicroMessenger|Snapchat/i.test(ua);
}

/**
 * GIS redirect UX needs Authorized redirect URIs in Google Cloud Console.
 * Use it only for in-app webviews; regular mobile Safari/Chrome use popup + COOP.
 */
export function needsGoogleRedirectLogin() {
  return isInAppBrowser();
}
